import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getMenuInfo } from "@/api/common.js";

let loadAsyncRouter = false;
router.beforeEach((to, from, next) => {
  NProgress.start();
  // 菜单仅从接口拉取并写入 Vuex，不使用 localStorage
  if (!loadAsyncRouter && !to.meta.showMain) {
    if (to.meta.showfoote) {
      localStorage.setItem("library_isHome", true);
    }
    localStorage.removeItem("library_menuData");
    getMenuInfo()
      .then((res) => {
        if (res.data && res.data.rows) {
          loadAsyncRouter = true;
          store.commit("SET_MENUDATA", res.data.rows);
        }
        next();
      })
      .catch(() => {
        next();
      });
  } else {
    next();
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});
